import { withInstall } from '@xzx-design/utils'
import _ImagePreview from './src/image-preview'

export const ImagePreview = withInstall(_ImagePreview)
export default ImagePreview

export * from './src/image-preview'
export * from './src/image-preview-item'
export * from './src/function-call'
export * from './src/types'
